import React from 'react';

/* Tab icons — original SVG paths kept intact. The previous version
   had hardcoded `fill="#A1A1A1"`, `fill="white"` and `fill="black"
   fill-opacity=0.3` on the <path> elements, which overrode whatever
   `color` prop was passed in. They now use `fill="currentColor"`, so
   the icon color flows from the parent button's CSS `color`
   property — exactly mirroring Figma's setup where the icon
   inherits the label color (active = white, inactive = #A1A1A1). */

export const OptionsIcon: React.FC = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M10.3367 6.41732C10.2349 6.24099 10.0887 6.09437 9.91268 5.99204C9.73667 5.8897 9.53693 5.83521 9.33333 5.83398H3.5V8.16732H8.66833L16.4967 21.584C16.5985 21.7603 16.7446 21.9069 16.9207 22.0093C17.0967 22.1116 17.2964 22.1661 17.5 22.1673H24.5V19.834H18.165L10.3367 6.41732ZM17.5 5.83398H24.5V8.16732H17.5V5.83398Z" />
  </svg>
);

export const MapIcon: React.FC = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M17.5 24.5008L10.5 22.0508L3.5 24.7633V5.89245L10.5 3.50078L17.5 5.95078L24.5 3.23828V22.1091L17.5 24.5008ZM16.3333 21.6424V7.99245L11.6667 6.35911V20.0091L16.3333 21.6424ZM18.6667 21.6424L22.1667 20.4758V6.65078L18.6667 7.99245V21.6424ZM5.83333 21.3508L9.33333 20.0091V6.35911L5.83333 7.52578V21.3508Z" />
  </svg>
);

export const PinIcon: React.FC = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M13.9999 7.58398C14.7735 7.58398 15.5153 7.89128 16.0623 8.43826C16.6093 8.98524 16.9166 9.7271 16.9166 10.5007C16.9166 10.8837 16.8411 11.2629 16.6946 11.6168C16.548 11.9707 16.3332 12.2922 16.0623 12.563C15.7915 12.8339 15.4699 13.0487 15.1161 13.1953C14.7622 13.3419 14.3829 13.4173 13.9999 13.4173C13.2264 13.4173 12.4845 13.11 11.9375 12.563C11.3905 12.0161 11.0833 11.2742 11.0833 10.5007C11.0833 9.7271 11.3905 8.98524 11.9375 8.43826C12.4845 7.89128 13.2264 7.58398 13.9999 7.58398ZM13.9999 2.33398C16.1659 2.33398 18.2431 3.1944 19.7746 4.72595C21.3062 6.25749 22.1666 8.33472 22.1666 10.5007C22.1666 16.6257 13.9999 25.6673 13.9999 25.6673C13.9999 25.6673 5.83325 16.6257 5.83325 10.5007C5.83325 8.33472 6.69367 6.25749 8.22521 4.72595C9.75676 3.1944 11.834 2.33398 13.9999 2.33398ZM13.9999 4.66732C12.4528 4.66732 10.9691 5.2819 9.87513 6.37586C8.78117 7.46982 8.16659 8.95356 8.16659 10.5007C8.16659 11.6673 8.16659 14.0007 13.9999 21.829C19.8333 14.0007 19.8333 11.6673 19.8333 10.5007C19.8333 8.95356 19.2187 7.46982 18.1247 6.37586C17.0307 5.2819 15.547 4.66732 13.9999 4.66732Z" />
  </svg>
);
